import { GridColDef } from '@mui/x-data-grid';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import Icons from '../../../components/icons';
import { Subject } from '../types';

export const getSubjectAndGroupingColumns = (
  onEdit: (subject: Subject) => void,
  onDelete: (subject: Subject) => void
): GridColDef[] => {
  return [
    { field: 'id', headerName: 'ID' },
    {
      field: 'Actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Box>
          <Tooltip title='Edit'>
            <IconButton onClick={() => onEdit(params.row as Subject)}>
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title='Delete'>
            <IconButton onClick={() => onDelete(params.row as Subject)}>
              <Icons.Delete height={18} width={18} />
            </IconButton>
          </Tooltip>
        </Box>
      )
    },
    { field: 'name', headerName: 'Subject Name', minWidth: 200 },
    { field: 'type', headerName: 'Type', minWidth: 120 },
    {
      field: 'isElective',
      headerName: 'Is Elective',
      minWidth: 120,
      renderCell: (params) => (
        <Typography>{params.value ? 'Yes' : 'No'}</Typography>
      )
    },
    { field: 'code', headerName: 'Subject Code', minWidth: 150, flex: 1 },
    {
      field: 'orderSequence',
      headerName: 'Order Sequence',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'reportGroup',
      headerName: 'Report Group',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'reportSubGroup',
      headerName: 'Report Sub-Group',
      minWidth: 280,
      flex: 1
    },
    {
      field: 'reportCardLabel',
      headerName: 'Report Card Label',
      minWidth: 180,
      flex: 1
    }
  ];
};
